import DataItem from './DataItem'
import { getWarranty } from '../../../utils/uploads'

const toYN = (value) => (value ? 'Yes' : 'No')

const Addons = ({ upload }) => {
  const { warranty, ixiFlasher } = upload.addons.reduce(
    (acc, addon) => {
      if (addon.type === 'WARRANTY_12' || addon.type === 'WARRANTY_24') {
        acc.warranty.available = true

        if (addon.purchased) {
          acc.warranty = { ...acc.warranty, ...addon }
        }
      }

      if (addon.type === 'IXI_FLASHER_SURCHARGE') {
        acc.ixiFlasher.available = true

        if (addon.purchased) {
          acc.ixiFlasher = { ...acc.ixiFlasher, ...addon }
        }
      }

      return acc
    },
    {
      warranty: {
        purchased: false,
        selected: false,
        available: false,
        type: 'WARRANTY_12',
      },
      ixiFlasher: {
        purchased: false,
        selected: false,
        available: false,
        type: 'IXI_FLASHER_SURCHARGE',
      },
    },
  )

  return (
    <div className="divide-y divide-gray-200">
      <div className="pt-6 pb-4 pl-6">
        <h4 className="font-semibold tracking-tight text-lg mb-0.5">
          ECU warranty
        </h4>
        <p className="text-gray-600 text-sm">
          If anything goes wrong during the writing process TGT will fix or
          replace the unit under this warranty for FREE.
        </p>
        <div className="divide-y divide-gray-200 mt-2">
          <DataItem label="Purchased" value={toYN(upload.ecuWarranty)} />
        </div>
      </div>
      {warranty.available && (
        <div className="pt-6 pb-4 pl-6">
          <h4 className="font-semibold tracking-tight text-lg mb-0.5">
            Mechanical warranty
          </h4>
          <p className="text-gray-600 text-sm">
            12 or 24 month mechanical warranty for your customer's vehicle.
          </p>
          <div className="divide-y divide-gray-200 mt-2">
            <DataItem label="Purchased" value={toYN(warranty.purchased)} />
            {warranty.purchased && (
              <>
                <DataItem label="Term" value={getWarranty(warranty.type)} />
                <DataItem
                  label="Customer name"
                  value={warranty.data.customerName}
                />
                <DataItem
                  label="Customer email"
                  value={warranty.data.customerEmail}
                />
              </>
            )}
          </div>
        </div>
      )}
      {ixiFlasher.available && (
        <div className="pt-6 pb-4 pl-6">
          <h4 className="font-semibold tracking-tight text-lg mb-0.5">
            IXI Flasher surcharge
          </h4>
          <p className="text-gray-600 text-sm">
            Additional fee for using IXI Flasher
          </p>
          <div className="divide-y divide-gray-200 mt-2">
            <DataItem
              label="Surcharge paid"
              value={toYN(ixiFlasher.purchased)}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Addons
